import React, { useState, useEffect } from 'react';

import './ImageSection.scss';

const ImageSection = ({ image, caption, alt }) => {
    const [imageUrls, setImageUrls] = useState({ webp: '', jpg: '' });
    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });

    const getOptimizedImageUrl = (image, format = 'jpg') => {
        if (!image?.fields?.file) return '';

        const originalWidth = image.fields.file.details.image.width;
        const originalHeight = image.fields.file.details.image.height;
        const windowWidth = window.innerWidth;

        let targetWidth;
        if (windowWidth < 768) {
            targetWidth = Math.min(windowWidth * 0.9, originalWidth); // 90% of screen width on mobile
        } else {
            targetWidth = Math.min(700, originalWidth); // Max width of 500px on desktop
        }

        // Calculate height maintaining aspect ratio
        const targetHeight = Math.round((targetWidth / originalWidth) * originalHeight);

        // Account for retina displays
        const pixelRatio = Math.min(window.devicePixelRatio || 1, 2.5);
        const requestWidth = Math.round(targetWidth * pixelRatio);
        const requestHeight = Math.round(targetHeight * pixelRatio);

        // Update dimensions state with the target dimensions (not the request dimensions which are for high DPI)
        setImageDimensions({ width: Math.round(targetWidth), height: targetHeight });

        return `${image.fields.file.url}?w=${requestWidth}&h=${requestHeight}&fm=${format}&fit=fill&q=${format === 'webp' ? 90 : 85}`;
    };

    useEffect(() => {
        if (image) {
            const updateImageUrls = () => {
                setImageUrls({
                    webp: getOptimizedImageUrl(image, 'webp'),
                    jpg: getOptimizedImageUrl(image, 'jpg')
                });
            };
            updateImageUrls();
            window.addEventListener('resize', updateImageUrls);
            return () => window.removeEventListener('resize', updateImageUrls);
        }
    }, [image]);

    return (
        <section className="image-section">
            <picture>
                <source srcSet={imageUrls.webp} type="image/webp" />
                <source srcSet={imageUrls.jpg} type="image/jpeg" />
                <img
                    src={imageUrls.jpg || image?.fields?.file?.url}
                    alt={alt || caption || 'Image'}
                    loading="lazy"
                    width={imageDimensions.width}
                    height={imageDimensions.height}
                />
            </picture>
            {caption && <p className="caption">{caption}</p>}
        </section>
    );
};

export default ImageSection; 